import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  labelData: {},
  pageFlag: 'create'
}

export const labelSlice = createSlice({
  name: 'label',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setLabelDataAction: (state, action) => {
      state.labelData = action.payload
    },
    setLabelPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setLabelDataAction, setLabelPageFlagAction } = labelSlice.actions

// Selectors
export const selectLabelData = (state) => state.label.labelData
export const selectLabelPageFlag = (state) => state.label.pageFlag

// Reducer
export default labelSlice.reducer